import { render } from "./SiteHero.vue?vue&type=template&id=22089220&scoped=true"
import script from "./SiteHero.vue?vue&type=script&lang=js"
export * from "./SiteHero.vue?vue&type=script&lang=js"

import "./SiteHero.vue?vue&type=style&index=0&id=22089220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22089220"]])

export default __exports__